import React, { useEffect, useState, useCallback } from "react";
// import PageHeader from "../../components/Header/PageHeader"; // удалено
import { useTranslation } from "react-i18next";
import { fetchWrapper } from "../../helpers";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.css";
import { useSelector } from "react-redux";
import axios from "axios";
import { Layout, Row, Col, Card, Space, Typography, Button, Divider, Tabs, Select, Slider, Drawer, message, notification, Input, Tag, Tooltip } from "antd";
import { ThunderboltOutlined, AudioOutlined, LinkedinOutlined, InstagramOutlined, FacebookOutlined, SaveOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { contentPlanActions, postActions, questionsActions } from "../../store";
import AudioRecorder from "audio-recorder-polyfill";
import i18n from "i18next";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { SETTINGS } from "../../constants/settings";
import { ImeanHeader } from "../../components/Header/Header";
import { StickyNavigationHeader } from "../../components/Navigation/StickyNavigationHeader";
import ResponsiveDateTimePicker from "../../components/DateTimePicker/ResponsiveDateTimePicker"
import GenerationFormatPicker from "../../components/GenerationFormatPicker";
import threadsIcon from "../icons/threads-mini.svg"
import CollaboratorsPicker from "../../components/Forms/CollaboratorsForm";
import MicRecorder from "../../components/Recorders/MicRecorder";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

const ts = (key, fallback = "") => {
    // allow objects to come through, pick active language or first value
    const v = i18n?.t ? i18n.t(key, { returnObjects: true, defaultValue: fallback }) : fallback;
    if (typeof v === "string") return v;
    if (v && typeof v === "object") {
        return v[i18n.language] || v.en || Object.values(v)[0] || fallback;
    }
    return fallback;
};

export const GeneratePost = () => {
    const memoizedPostFormats = JSON.parse(localStorage.getItem("postFormats")) || undefined;
    if (typeof window !== "undefined" && typeof window.MediaRecorder === "undefined") {
        window.MediaRecorder = AudioRecorder;
    }
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [tokens, setTokens] = useState({
        facebook: false,
        instagram: false,
        linkedin: false,
        threads: false,
    });
    const [postDescription, setPostDescription] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const getInputDatetime = () => {
        const d = new Date();
        return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -5).slice(0, -3);
    };
    const [date, setDate] = useState(() => getInputDatetime());
    const [sn, setSn] = useState([]);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [contentFormats, setContentFormats] = useState([]);
    const [selectedContentFormatId, setSelectedContentFormatId] = useState(null);
    const [selectedContentLangs, setSelectedContentLangs] = useState(memoizedPostFormats?.contentLangs || []);
    const [postModel, setPostModel] = useState(memoizedPostFormats?.postModel || SETTINGS.POST_MODEL.DEFAULT);
    const [postLength, setPostLength] = useState(memoizedPostFormats?.postLength || SETTINGS.POST_LENGTH.DEFAULT);
    const [postEmojis, setPostEmojis] = useState(memoizedPostFormats?.postEmojis || SETTINGS.POST_EMOJIS.DEFAULT);
    const [collaborators, setCollaborators] = useState([]);
    // console.log('postDescription', postDescription);
    const contentPlan = useSelector((obj) => obj.contentPlan.contentPlan);
    const location = useLocation();
    const { search } = useLocation();

    const [postLoading, setPostLoading] = useState(false);
    const [isMicActive, setIsMicActive] = useState(false);
    const [isStories, setIsStories] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);

    const currentLang = i18n.language;

    const [fmtLoading, setFmtLoading] = useState(false);
    const [fmtError, setFmtError] = useState(null);

    const loadFormats = useCallback(async () => {
        try {
            setFmtError(null);
            setFmtLoading(true);
            fetchWrapper.get(`${baseUrl}/postformats`).then((res) => {
                setContentFormats(res);
            });
        } catch (e) {
            console.error(e);
            setFmtError(e?.message || "Failed to load formats");
        } finally {
            setFmtLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/postformats`).then((res) => {
            setContentFormats(res);
        });
    }, []);

    const selectedSet = React.useMemo(() => new Set(sn), [sn]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const qDate = params.get("date");
        if (!qDate) return;

        const now = dayjs();
        let target = dayjs(qDate, qDate.includes("T") ? "YYYY-MM-DDTHH:mm" : "YYYY-MM-DD", true);
        if (!target.isValid()) return;
        if (!qDate.includes("T")) {
            target = target.hour(now.hour()).minute(now.minute());
        }
        setDate(target.format("YYYY-MM-DDTHH:mm"));
    }, [location.search]);



    useEffect(() => {
        const qs = new URLSearchParams(search);
        const d = qs.get("date");
        if (d) {
            const t = dayjs(date);
            const next = dayjs(d).hour(t.hour()).minute(t.minute());
            setDate(next.format("YYYY-MM-DDTHH:mm"));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const openNotificationEndSubscribe = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/subscription-plans")}>
                    {ts("posts.goToRate")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: ts("functions.error"),
            description: ts("posts.limit"),
            btn,
            key,
        });
    };

    const openNotificationSocialNetwork = ({ message, description }) => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/profile")}>
                    {ts("posts.goToProfile")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: message || ts("functions.error"),
            description: description || ts("posts.unknownError"),
            btn,
            key,
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (!postDescription.trim()) {
            message.warning(ts("functions.noText"));
            return;
        }
        if (postDescription.length > 2000) {
            message.error(ts("functions.maxTextLength", { limit: 2000 }));
            return;
        }

        setPostLoading(true);

        const event = dayjs(date).toDate();
        fetchWrapper
            .post(`${baseUrl}/post/save`, {
                description: postDescription,
                socialNetwork: sn.join(","),
                date: event.toISOString(),
                formatId: selectedContentFormatId,
                selectedContentLangs,
                postLength,
                postEmojis,
                postModel,
                isStories: isStories,
                collaborators: collaborators.length > 0 ? collaborators : [],
            })
            .then((res) => {
                navigate(`/create-post/${res.contentPlanId}`);
            })
            .catch((err) => {
                if (err === "Достигнут лимит действий") {
                    openNotificationEndSubscribe();
                } else {
                    openNotification();
                }
                setPostLoading(false);
            });
    };

    const startRecording = () => {
        navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
                setIsMicActive(true);
                const recorder = new MediaRecorder(stream);
                recorder.start();
                setMediaRecorder(recorder);
                recorder.addEventListener("dataavailable", (e) => {
                    message.loading(ts("functions.loading"));
                    const audioBlob = new Blob([e.data], { type: "audio/wav" });
                    const audioFile = new File([audioBlob], "recording.wav", {
                        type: "audio/wav",
                    });
                    const formData = new FormData();
                    formData.append("audio", audioFile);

                    axios({
                        method: "POST",
                        url: `${process.env.REACT_APP_API_URL}/upload-audio`,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        data: formData,
                    })
                        .then((data) => data.data && setPostDescription((postDescription) => `${postDescription || ""}${data.data.text}`))
                        .catch((error) => console.error(error));
                });
            })
            .catch((error) => {
                message.error(ts("functions.microphone"));
            });
    };

    const stopRecording = () => {
        mediaRecorder?.stop();
        // You might want to do something with the audio chunks here, like creating a blob and saving or playing it
        const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
        // Resetting audio chunks after recording is stopped
        setAudioChunks([]);
        setIsMicActive(false);
        // Here, you could save the blob or do something else with it
    };

    const handleRememberOptionsPublicationFormats = () => {
        const memoValues = {
            postModel: postModel,
            postLength: postLength,
            postEmojis: postEmojis,
            contentLangs: selectedContentLangs,
        };
        localStorage.setItem("postFormats", JSON.stringify(memoValues));
        message.success(ts("functions.successfullySaved"));
    };

    useEffect(() => {
        return () => {
            mediaRecorder?.state === "recording" && mediaRecorder.stop();
        };
    }, [mediaRecorder]);

    const toggleMic = () => {
        if (isMicActive) {
            stopRecording();
        } else {
            startRecording();
        }
    };

    const onChangeTextarea = (e) => {
        setPostDescription(e.target.value);
    };

    const handleChangeGeneratedLangs = (value) => setSelectedContentLangs(value);

    // Fetch tokens once
    useEffect(() => {
        fetchWrapper
            .get(`${baseUrl}/auth/getSocialMediaTokens/`)
            .then((res) => {
                const filteredToken = { facebook: false, instagram: false, linkedin: false, threads: false };
                res.forEach((token) => {
                    if (token.socialMediaType === "FACEBOOK") filteredToken.facebook = true;
                    if (token.socialMediaType === "INSTAGRAM") filteredToken.instagram = true;
                    if (token.socialMediaType === "LINKEDIN") filteredToken.linkedin = true;
                    if (token.socialMediaType === "THREADS") filteredToken.threads = true;
                });
                setTokens(filteredToken);
                setSn(filteredToken.linkedin ? ["LinkedIn"] : []); // авто‑выбор LinkedIn если доступен
            })
            .catch(() => { });
    }, []);

    // // Fetch post formats once
    // useEffect(() => {
    //     fetchWrapper
    //         .get(`${baseUrl}/postformats`)
    //         .then((res) => setContentFormats(res))
    //         .catch(() => {});
    // }, []);

    const toggleSN = (name) => {
        const map = { LinkedIn: "linkedin", Instagram: "instagram", Facebook: "facebook", Threads: "threads" };
        if (!tokens[map[name]]) {
            openNotificationSocialNetwork({
                message: ts("functions.error"),
                description: ts(`posts.notLinked-${map[name]}`),
            });
            return;
        }
        setSn((prev) => (prev.includes(name) ? prev.filter((v) => v !== name) : [...prev, name]));
    };

    const openNotification = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/support")}>
                    Tech support
                </Button>
            </Space>
        );
        notificationApi.open({
            message: ts("functions.error"),
            description: ts("posts.unknownError"),
            btn,
            key,
        });
    };

    const toggleStories = () => {
        setIsStories((prev) => {
            const next = !prev;
            if (next && collaborators.length) {
                setCollaborators([]);
                message.info(t("posts.storiesWithoutCollab"));
            }
            return next;
        });
    };



    return (
        <>
            {/* Глобальный Header */}
            <ImeanHeader initialDark={true} />
            {/* Top Bar */}
            <StickyNavigationHeader headerTitle={t('postPage.cards.postTitle')}
                onBackClick={() => {
                    if (window.history.state && window.history.state.idx > 0) {
                        navigate(-1);
                    } else {
                        navigate('/posts');
                    }
                }}></StickyNavigationHeader>
            <Layout style={{ minHeight: '100vh', background: 'linear-gradient(180deg, #ffffff, #faf5ff)' }}>

                {/* CONTENT */}
                <Layout.Content style={{ maxWidth: 1200, margin: "24px auto", width: "100%", padding: "0 16px" }}>
                    {contextHolder}
                    {notificationContextHolder}
                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={14}>
                            <Card bordered className="shadow-sm" bodyStyle={{ padding: 16 }}>
                                <Row align="middle" justify="space-between">
                                    <Space size={12} align="center">
                                        <Typography.Title level={5} style={{ margin: 0 }}>
                                            {t("postPage.cards.targetScheduleTitle")}
                                        </Typography.Title>
                                    </Space>
                                    <Space split={<Divider type="vertical" />} style={{ color: '#8c8c8c' }}>
                                        {sn.includes('Instagram') && <Space style={{ color: '#1677ff' }}><InstagramOutlined />Instagram</Space>}
                                        {sn.includes('LinkedIn') && <Space style={{ color: '#1677ff' }}><LinkedinOutlined />LinkedIn</Space>}
                                        {sn.includes('Facebook') && <Space style={{ color: '#1677ff' }}><FacebookOutlined />Facebook</Space>}
                                        {sn.includes('Threads') && (
                                            <Space style={{ color: '#1677ff', display: 'inline-flex', alignItems: 'center' }}>
                                                <img
                                                    src={threadsIcon}
                                                    alt="Threads"
                                                    style={{
                                                        width: 14,
                                                        height: 14,
                                                        filter: 'invert(31%) sepia(94%) saturate(1799%) hue-rotate(213deg) brightness(95%) contrast(95%)'
                                                    }}
                                                />
                                                Threads
                                            </Space>
                                        )}
                                    </Space>
                                </Row>
                                <Divider style={{ margin: "12px 0" }} />
                                <Row gutter={[12, 12]}>
                                    <Col xs={24} md={12}>
                                        <Card size="small" bordered>
                                            <Space direction="vertical" style={{ width: "100%" }}>
                                                <Typography.Text strong>{t("postPage.cards.platforms")}</Typography.Text>
                                                <Row gutter={[8, 8]}>
                                                    <Col xs={24} sm={12} md={8}>
                                                        <Button block size="small" icon={<LinkedinOutlined />} disabled={!tokens.linkedin} type={sn.includes("LinkedIn") ? "primary" : "default"} ghost={sn.includes("LinkedIn")} onClick={() => toggleSN("LinkedIn")} style={{ whiteSpace: "nowrap" }}>
                                                            LinkedIn
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} sm={12} md={8}>
                                                        <Button block size="small" icon={<InstagramOutlined />} disabled={!tokens.instagram} type={sn.includes("Instagram") ? "primary" : "default"} ghost={sn.includes("Instagram")} onClick={() => toggleSN("Instagram")} style={{ whiteSpace: "nowrap" }}>
                                                            Instagram
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} sm={12} md={8}>
                                                        <Button block size="small" icon={<FacebookOutlined />} disabled={!tokens.facebook} type={sn.includes("Facebook") ? "primary" : "default"} ghost={sn.includes("Facebook")} onClick={() => toggleSN("Facebook")} style={{ whiteSpace: "nowrap" }}>
                                                            Facebook
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} sm={12} md={8}>
                                                        <Button block
                                                                size="small"
                                                                disabled={!tokens.threads}
                                                                type={sn.includes("Threads") ? "primary" : "default"}
                                                                ghost={sn.includes("Threads")}
                                                                onClick={() => toggleSN("Threads")}
                                                                style={{ whiteSpace: "nowrap" }}
                                                                icon={
                                                                    <img
                                                                        src={threadsIcon}
                                                                        alt="Threads"
                                                                        style={{
                                                                            width: 14,
                                                                            height: 14,
                                                                            filter: sn.includes("Threads")
                                                                                ? 'invert(31%) sepia(94%) saturate(1799%) hue-rotate(213deg) brightness(95%) contrast(95%)'
                                                                                : 'none'
                                                                        }}
                                                                    />
                                                                }
                                                        >
                                                            Threads
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {sn.length === 0 ? t("postPage.cards.linkAcc") : null}
                                                </Typography.Text>
                                            </Space>
                                        </Card>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Card size="small" bordered>
                                            <Space direction="vertical" style={{ width: '100%' }}>
                                                <Typography.Text strong>{t('postPage.cards.schedule')}</Typography.Text>
                                                <ResponsiveDateTimePicker
                                                    value={date ? dayjs(date) : null}
                                                    onChange={(d) => setDate(d ? d.format("YYYY-MM-DDTHH:mm") : "")}
                                                    placeholder={t('postPage.cards.schedule')}
                                                    minDate={new Date()}
                                                    disabledDate={(current) => current && current < dayjs().startOf("day")}
                                                />
                                                <Typography.Text type="secondary"
                                                    style={{ fontSize: 12 }}>{t('postPage.cards.localTime')}</Typography.Text>
                                            </Space>
                                        </Card>
                                    </Col>
                                    {sn.includes('Instagram') && !isStories && (
                                        <Col xs={24}>
                                            <Card size="small" bordered>
                                                <CollaboratorsPicker
                                                    value={collaborators}
                                                    onChange={setCollaborators}
                                                    isStories={isStories}
                                                    max={5}
                                                />
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                            </Card>
                            <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                                <Row justify="space-between" align="middle">
                                    <Typography.Title level={5} style={{ margin: 0 }}>
                                        {t("postPage.cards.whatPostSay")}
                                    </Typography.Title>
                                    <Space split={<Divider type="vertical" />}>
                                        {sn.includes("Instagram") && (
                                            <Button size="small" type="primary" ghost={!isStories} onClick={toggleStories}>
                                                Stories
                                            </Button>
                                        )}
                                        <Typography.Text type="secondary">{t("postPage.cards.characters")}:</Typography.Text>
                                        <Typography.Text>{postDescription.length}/2000</Typography.Text>
                                    </Space>
                                </Row>
                                <Divider style={{ margin: "12px 0" }} />
                                <Input.TextArea value={postDescription} onChange={onChangeTextarea} placeholder={t("postPage.placeholders.addDetails")} autoSize={{ minRows: 8, maxRows: 14 }} maxLength={2000} />
                                <div className="flex flex-wrap gap-2 mt-3 sm:flex-row flex-col w-full">
                                    <Button block onClick={() => setPostDescription("")}>
                                        {t("postPage.buttons.clear")}
                                    </Button>
                                    <Button block onClick={() => setDrawerVisible(true)}>
                                        {t("postPage.buttons.settings")}
                                    </Button>
                                    <MicRecorder
                                        baseUrl={baseUrl}
                                        getInitialText={() => postDescription}
                                        onUpdate={(fullText) => setPostDescription(fullText)}
                                    />
                                    <Button block type="primary" icon={<ThunderboltOutlined />} onClick={onSubmit} loading={postLoading} disabled={sn.length === 0 || !postDescription.trim()}>
                                        {t("postPage.buttons.generate")}
                                    </Button>
                                </div>
                                {/* </Space> */}
                            </Card>
                            <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                                <Space direction="vertical" style={{ width: "100%" }} size={8}>
                                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                        {t("postPage.hint.hintText")}
                                    </Typography.Text>
                                    <Space split={<Divider type="vertical" />}>
                                        <Typography.Text type="secondary">{t("postPage.hint.shortcutSend")}</Typography.Text>
                                        <Typography.Text type="secondary">{t("postPage.hint.shortcutPaste")}</Typography.Text>
                                    </Space>
                                </Space>
                            </Card>
                        </Col>
                        <Col xs={24} lg={10}>
                            {/* Generation Options */}
                            <Card className="shadow-sm" style={{ marginTop: 16 }} bodyStyle={{ padding: 16 }}>
                                <Row align="middle" justify="space-between">
                                    <Typography.Title level={5} style={{ margin: 0 }}>
                                        {t("postPage.cards.generationOptions")}
                                    </Typography.Title>
                                    {/* <Button onClick={handleRememberOptionsPublicationFormats} icon={<SaveOutlined />} disabled>
                                        {t("postPage.buttons.remember")}
                                    </Button> */}
                                </Row>
                                <Divider style={{ margin: "12px 0" }} />

                                <Row gutter={[12, 12]}>
                                    <Col xs={24} md={24}>
                                        <Card size="small" bordered>
                                            <Space direction="vertical" style={{ width: "100%" }}>
                                                <Typography.Text strong>{t("postPage.cards.formatPostTitle") || "Publication format"}</Typography.Text>
                                                <GenerationFormatPicker
                                                    value={selectedContentFormatId}
                                                    onChange={(id) => setSelectedContentFormatId(id)}
                                                    data={contentFormats} // pass your existing list; or omit and provide `load`
                                                    loading={fmtLoading}
                                                    error={fmtError}
                                                    load={loadFormats}
                                                    i18nLang={currentLang}
                                                />
                                                <Typography.Text type="secondary">{t("home.formatPost") || "Tune languages, length, emojis, and format before generating."}</Typography.Text>
                                            </Space>
                                        </Card>
                                    </Col>

                                    <Col xs={24} md={24}>
                                        <Card size="small" bordered>
                                            <Space direction="vertical" style={{ width: "100%" }}>
                                                <Typography.Text strong>{t("posts.postLengthTitle") + ": " + postLength}</Typography.Text>
                                                <Slider value={postLength} onChange={setPostLength} min={SETTINGS.POST_LENGTH.MIN} max={SETTINGS.POST_LENGTH.MAX} tooltip={{ open: false }} />
                                                <Typography.Text strong>{t("postPage.cards.languagesPost")}</Typography.Text>
                                                <Select
                                                    mode="multiple"
                                                    value={selectedContentLangs}
                                                    onChange={handleChangeGeneratedLangs}
                                                    options={[
                                                        { value: "ru", label: "Русский" },
                                                        { value: "en", label: "English" },
                                                        { value: "kk", label: "Қазақша" },
                                                    ]}
                                                    placeholder={t("posts.selectLanguages")}
                                                    style={{ width: "100%" }}
                                                />
                                                <Divider style={{ margin: "8px 0" }} />
                                                <Typography.Text strong>{t("postPage.cards.emojisPost")}</Typography.Text>
                                                <Select
                                                    value={postEmojis}
                                                    onChange={setPostEmojis}
                                                    style={{ width: "100%" }}
                                                    options={[
                                                        { value: 0, label: t("postPage.toolbar.emojisOptions.none") || "None" },
                                                        { value: 1, label: t("postPage.toolbar.emojisOptions.few") || "Few" },
                                                        { value: 2, label: t("postPage.toolbar.emojisOptions.more") || "More" },
                                                    ]}
                                                />
                                                <Typography.Text strong>{t("postPage.cards.modelPost")}</Typography.Text>
                                                <Select
                                                    value={postModel}
                                                    onChange={setPostModel}
                                                    style={{ width: "100%" }}
                                                    options={[
                                                        { value: "advance", label: t("postPage.toolbar.modelOptions.default") || "Default" },
                                                        { value: "creative", label: t("postPage.toolbar.modelOptions.creative") || "Creative" },
                                                        { value: "formal", label: t("postPage.toolbar.modelOptions.formal") || "Formal" },
                                                    ]}
                                                />
                                            </Space>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Drawer title="Settings" open={drawerVisible} onClose={() => setDrawerVisible(false)} width={420}>
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Typography.Text type="secondary">Tune languages, length, emojis, and format before generating.</Typography.Text>
                        </Space>
                    </Drawer>
                </Layout.Content>
                {/*Removed the footer at user request*/}
            </Layout>
        </>
    );
};
